/* Olevia (tm) - defilement des CTA vers la fiche produit + selecteur de quantite */
(function () {
  if (window.__olvScrollInit) return;
  window.__olvScrollInit = true;

  function mainSection() {
    return (
      document.querySelector('[id^="shopify-section-"][id$="__main"]') ||
      document.querySelector('product-info, main-product, .product-information, .shopify-section .product') ||
      document.querySelector('main')
    );
  }

  function qtyNode() {
    return document.querySelector(
      'quantity-selector, quantity-input, .quantity-selector, .quantity-input, .quantity, ' +
      'input[name="quantity"], [id^="Quantity-"], [id^="quantity-"]'
    );
  }

  function headerOffset() {
    var h = document.querySelector('sticky-header, header, .header, #header');
    var v = h ? h.getBoundingClientRect().height : 0;
    if (!h || getComputedStyle(h).position !== 'fixed') {
      if (getComputedStyle(h || document.body).position !== 'sticky') v = Math.min(v, 90);
    }
    return v + 14;
  }

  /* defilement anime maison : ne depend pas de scroll-behavior du theme */
  function animateTo(y, ms, done) {
    var start = window.pageYOffset;
    var delta = y - start;
    if (Math.abs(delta) < 2) { if (done) done(); return; }
    var t0 = null;
    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / ms);
      var e = p < 0.5 ? 2 * p * p : -1 + (4 - 2 * p) * p; /* easeInOutQuad */
      window.scrollTo(0, start + delta * e);
      if (p < 1) requestAnimationFrame(step);
      else if (done) done();
    }
    requestAnimationFrame(step);
  }

  function highlightQty() {
    var q = qtyNode();
    if (!q) return;
    var box = q.closest ? (q.closest('quantity-selector, .quantity-selector, .quantity, .product-form__quantity') || q) : q;
    box.classList.add('olv-pulse');
    setTimeout(function () { box.classList.remove('olv-pulse'); }, 1900);
    var field = q.tagName === 'INPUT' ? q : q.querySelector('input');
    if (field) { try { field.focus({ preventScroll: true }); } catch (e) { } }
  }

  function goToBuyBox(ev) {
    if (ev) ev.preventDefault();
    var m = mainSection();
    if (!m) return;
    var y = m.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    animateTo(Math.max(0, y), 620, function () {
      /* deuxieme passe : le lazy-load peut avoir decale la page pendant le scroll */
      var y2 = m.getBoundingClientRect().top + window.pageYOffset - headerOffset();
      animateTo(Math.max(0, y2), 220, highlightQty);
    });
  }

  window.olvGoToBuyBox = goToBuyBox;

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-olv-scroll]') : null;
    if (t) goToBuyBox(e);
  });
})();
